<template>
  <div class="modal-mask">
    <cc-loader-full v-if="loading" />
    <div class="modal-content-container">
      <div class="new-product__header-container">
        <span class="new-product__header-title">Alterar Embalagem</span>
        <span @click="closeDialog" class="material-icons new-product__closebtn-icon">
          cancel
        </span>
      </div>

      <div class="packaging-info">
        <span class="packaging-client-name">Cliente: {{ client.name }}</span>
      </div>

      <ValidationObserver>
        <form @submit.prevent="save">
          <div class="edit-product__actions-container">
            <div
              class="edit-product__only-unit-input-wrapper edit-product__category-input-width"
            >
              <label class="edit-product__input-title">
                Unidade<span style="color: red !important">*</span>
              </label>
              <ValidationProvider rules="required" v-slot="v">
                <cc-select-v2
                  :tracker="'value'"
                  class="multiselect"
                  :placeholder="'Selecione a unidade'"
                  :text="'name'"
                  v-model="wrap"
                  :options="wraps"
                />
                <span class="error">{{ v.errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div
              class="edit-product__qty-package-input-wrapper edit-product__category-input-width"
            >
              <label class="edit-product__input-title">
                Qtd. Embalagem<span style="color: red !important">*</span>
              </label>
              <ValidationProvider rules="required|numeric" v-slot="v">
                <cc-input
                  class="code-input"
                  v-model="qtdEmbalagemModal"
                  type="number"
                  min="1"
                />
                <span class="error">{{ v.errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>

      <div class="update-buttons__container">

        <Button
          class="action-buttons"
          title="Cancelar alteração"
          :text="'Cancelar'"
          :action="closeDialog"
          style="margin-left: 15px"
        />
        <Button
        class="action-buttons"
        title="Confirmar alteração"
        :text="'Salvar'"
        :action="save"
        style="margin-left: 15px"
      />
      </div>
    </div>
  </div>
</template>

<script>
import ClientService from "@/services/v3/client.service.js";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Button from "@/components/ui/buttons/StandardButton.vue";

export default {
  mixins: [loaderMixin],
  props: {
    client: {
      type: Object,
      required: true,
    },
    closeDialog: {
      type: Function,
      required: true,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Button,
  },
  data() {
    return {
      wraps: [
        { name: "Unidade", value: "UN" },
        { name: "Caixa", value: "CX" },
        { name: "Fardo", value: "FD" },
        { name: "Quilo", value: "KG" },
        { name: "Dúzia", value: "DZ" },
      ],
      wrap: null,
      qtdEmbalagemModal: 1,
      loading: false,
      error_messages: "",
    };
  },
  methods: {
    async save() {
      this.loading = true;

      try {
        const packagingString = `${this.wrap.value} ${this.qtdEmbalagemModal}`;
        const svc = new ClientService();

        await svc.updateClientPackaging(this.client.id, packagingString);

        this.$swal.fire(
          "Sucesso!",
          "Embalagem alterada para todos os produtos do cliente.",
          "success"
        );
        this.closeDialog();
        this.$emit("packaging-updated");
      } catch (error) {
        console.error("Erro:", error);
        this.error_messages =
          error.response?.data?.message || "Ocorreu um erro ao alterar a embalagem.";
        this.$swal.fire("Erro!", this.error_messages, "error");
      } finally {
        this.loading = false;
      }
    },
    handlekeydown(e) {
      if (e.key === "Escape") {
          this.closeDialog()
      }
		}
  },
  mounted() {
		window.addEventListener('keydown', this.handlekeydown);
	},
	beforeDestroy(){
		window.removeEventListener('keydown', this.handlekeydown);
	}
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.modal-content-container {
  background-color: white;
  width: 40vw;
  min-width: 500px;
  border-radius: 12px;
}

.new-product__header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 10px 10px 0 0;
  background-color: var(--primary-color);
}

.new-product__header-title {
  color: #fff;
  font-weight: 500;
  font-size: 1.8em;
}

.new-product__closebtn-icon {
  color: #fff;
  font-size: 30px;
  cursor: pointer;
}

.packaging-info {
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.packaging-client-name {
  font-size: 1.2em;
  font-weight: 500;
  color: #333;
  display: block;
  margin-bottom: 5px;
}

.packaging-subtitle {
  font-size: 0.9em;
  color: #666;
}

.edit-product__actions-container {
  display: flex;
  padding: 20px;
  gap: 20px;
}

.edit-product__only-unit-input-wrapper,
.edit-product__qty-package-input-wrapper {
  flex: 1;
}

.edit-product__input-title {
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #898989;
  font-size: 1.2em;
  margin-bottom: 10px;
  display: block;
}

.error {
  color: #ff0000;
  font-size: 0.8em;
}

.update-buttons__container {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  border-top: 1px solid #eee;
}

.action-buttons {
  min-width: 120px;
}

@media only screen and (max-width: 768px) {
  .modal-content-container {
    width: 90vw;
    min-width: unset;
  }

  .edit-product__actions-container {
    flex-direction: column;
    gap: 15px;
  }
}
</style>
